import type {
  SystemScenarioRunRecord,
} from '@/governor/system-workspaces/SystemWorkspaceContracts';

import {
  ControlledSystemSimulatorEngine,
} from '@/governor/system-workspaces/ControlledSystemSimulatorEngine';

import {
  getSystemWorkspace,
} from '@/governor/system-workspaces/SystemWorkspaceRegistry';

import {
  TREE_CORRECTNESS_SCENARIO_IDS,
  TREE_SIMULATOR_SYSTEM_ID,
  registerTreeCorrectnessScenarioPackage,
  treeCorrectnessScenarios,
} from './TreeCorrectnessScenarioPackage';

import type {
  TreeRuntimeScenarioId,
} from './TreeRuntimeSimulator';

registerTreeCorrectnessScenarioPackage();

const treeCorrectnessSimulator =
  new ControlledSystemSimulatorEngine(
    getSystemWorkspace,
    {
      timeoutMs: 5_000,
    },
  );

export function listTreeCorrectnessScenarios() {
  return [...treeCorrectnessScenarios];
}

export function listTreeCorrectnessSimulationRuns() {
  return treeCorrectnessSimulator.listRuns(
    TREE_SIMULATOR_SYSTEM_ID,
  );
}

export function listTreeCorrectnessSimulationEvidence() {
  return treeCorrectnessSimulator.listEvidence(
    TREE_SIMULATOR_SYSTEM_ID,
  );
}

export async function runTreeCorrectnessScenario(
  scenarioId: TreeRuntimeScenarioId,
): Promise<SystemScenarioRunRecord> {
  return treeCorrectnessSimulator.execute(
    TREE_SIMULATOR_SYSTEM_ID,
    scenarioId,
  );
}

export async function runAllTreeCorrectnessScenarios():
  Promise<SystemScenarioRunRecord[]> {
  const results:
    SystemScenarioRunRecord[] = [];

  for (
    const scenarioId of
    TREE_CORRECTNESS_SCENARIO_IDS
  ) {
    results.push(
      await runTreeCorrectnessScenario(
        scenarioId,
      ),
    );
  }

  return results;
}
